import React, { useEffect } from 'react';
import { Field } from 'formik';
import Immutable from 'immutable';
import c from 'classnames';
import { useSelector } from 'react-redux';
import { isDate, differenceInMonths } from 'date-fns';

const tokenToArray = (token) => {
  return token.substring(1, token.length - 1).split(':');
};

const tokenReplacer = (token, referrerUrl) => {
  const urlSearchParams = new URLSearchParams(window ? window.location.search : '');
  const params = Object.fromEntries(urlSearchParams.entries());

  const values = Immutable.fromJS({
    headless: {
      'current-page': window ? window.location.href : null,
      referrer: referrerUrl,
      query: params,
    },
  });

  const array = [...token.matchAll(/\[.+?\]/g)];
  array.forEach(([item]) => {
    const elements = item.substring(1, item.length - 1).split(':');
    token = token.replace(item, values.getIn(elements, item));
  });

  return token;
};

// if the token "date_diff" is used we get the value of the requested field and calculate the months.
const tokenReplacerDateDiff = (token, props) => {
  // get the token value
  const tokenValue = props[token];

  const date = new Date(tokenValue);
  const now = new Date();

  // return the diff in months
  return isDate(date) ? differenceInMonths(now, date) : ''; // check if the value of the field in the token is a valid date, then diff it.
};

const WebformHidden = ({ entity, customClasses, setFieldValue, ...fieldProps }) => {
  const key = entity.get('#webform_key');
  const wrapperClassNames = c('WebformHidden', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  const defaultValue = entity.get('#default_value');
  const referrerUrl = useSelector((state) => state.getIn(['uiInternal', 'previousUrl', 'location', 'pathname']));
  const { values } = fieldProps;

  useEffect(() => {
    // which token is present
    const tokenArray = tokenToArray(defaultValue);
    // For now we only have 'date_diff' and the default option available.
    // If date_diff token is used, get the correct value, otherwise use the default tokenReplacer which we used for the url parameters
    const tokenValue = tokenArray[1] === 'date_diff' ? tokenReplacerDateDiff(tokenArray[2], values) : tokenReplacer(defaultValue, referrerUrl);
    // Get name of the key of the field from the token array if it exists
    const keyPrefix = tokenArray[1] === 'date_diff' && tokenArray[2] || '';
    // If default token is used, set true, otherwise check if input
    const allFilled = tokenArray[1] === 'date_diff' ? typeof values[`${keyPrefix}day`] === 'number' && typeof values[`${keyPrefix}month`] === 'number' && typeof values[`${keyPrefix}day`] === 'number' : true;

    const newValue = allFilled && !Number.isNaN(tokenValue) ? tokenValue : '';

    // Set the hidden field value
    setFieldValue(key, newValue);
  }, [referrerUrl, setFieldValue, key, defaultValue, values]);
  return (
    <div className={wrapperClassNames}>
      <Field
        className="hidden"
        name={key}
        type="text"
        value={fieldProps.values[key]}
      />
    </div>
  );
};

export default WebformHidden;
